module.exports = __webpack_public_path__ + "static/media/noun_devices_217202.2f1824da.svg";